module.exports = __webpack_public_path__ + "static/media/nft.fbbe130e.jpg";